import React, { ReactNode, Fragment, Suspense } from "react";
import { Table as BsTable, TableProps } from "reactstrap";

import cx from "clsx";

type IColumn = {
  title?: string | ReactNode;
  dataIndex: string;
  colSpan?: number;
  render?(value: ReactNode | string, row: object, rowKey: number): void;
  collapse?(value: ReactNode | string, row: object, rowKey: number): ReactNode;
  children?: Array<IColumn>;
};

type ExtendedProps = Pick<TableProps, "bordered" | "borderless" | "hover">;

export type Props = ExtendedProps & {
  columns?: Array<IColumn>;
  data?: Array<object>;
  className?: string;
  headerClass?: string;
  centered?: boolean;
  onRowClick?(row: any): void;
};
const loading = () => <div className="text-center" />;

const Table = ({
  columns = [],
  data = [],
  className,
  headerClass,
  bordered,
  borderless,
  centered,
  hover,
  onRowClick = () => {}
}: Props) => {
  const classes = cx(className, {
    "table-hover": hover,
    "table-bordered": bordered,
    "table-borderless": borderless,
    "table-centered": centered
  });

    return data.length === 0 ? <p>Loading...</p> : <BsTable className={classes} id="table-to-xls">
      <thead className={headerClass}>
        <tr>
          <th>#</th>
          {columns.map(({ title, colSpan }: IColumn, columnKey: number) => (
            <th key={columnKey} colSpan={colSpan}>
              {title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        { data.map((row: any, rowKey: number) => (
          <tr key={rowKey} onClick={() => onRowClick(row)}>
            <td>{rowKey + 1}</td>
            {row && columns.map(({ dataIndex, render, collapse }: IColumn, columnKey: number) => (
              <Fragment key={columnKey}>
                <td>{render ? render(row[dataIndex], row, rowKey) : row[dataIndex]}</td>
                {collapse && <td>{collapse(row[dataIndex], row, rowKey)}</td>}
              </Fragment>
            ))}
          </tr>
        )) }
      </tbody>
    </BsTable>;
};

export default Table;
